<template>
    <div class="select-none">
        <student-worksheet-module-wrapper
            :module="module"
            :module-complete="response.module_complete"
            :worksheet-complete="worksheetComplete"
        >
            <div
                :class="
                    'px-8 pb-8' +
                    ' ' +
                    (module.prompt && module.prompt.length ? 'pb-0' : 'pt-8')
                "
            >
                <div class="px-6 py-2 text-center text-[16px] text-gray-625">
                    Label the diagram shown below by dragging each term to the
                    input box corresponding with its number
                </div>
                <div class="relative mb-8 w-full border-gray-200">
                    <img :src="module.content.image.src" />
                </div>

                <div class="grid grid-cols-2 gap-4">
                    <div class="flex h-full flex-col">
                        <div class="flex-shrink font-semibold text-gray-800">
                            Your Answers
                        </div>
                        <div
                            :class="
                                'flex flex-grow flex-col gap-2 p-2' +
                                ' ' +
                                (response.module_complete
                                    ? 'bg-green-50'
                                    : 'bg-gray-125')
                            "
                        >
                            <div
                                class="flex h-full w-full items-center justify-start gap-2 border-gray-225 p-2 text-gray-800"
                                v-for="(labelTarget, index) in labelTargets"
                            >
                                <div
                                    class="flex h-10 w-10 items-center justify-center rounded border border-gray-725 p-2 text-gray-725"
                                >
                                    {{ index + 1 }}
                                </div>

                                <draggable
                                    v-model="labelTarget.selectedAnswer"
                                    :disabled="response.module_complete"
                                    :group="'items' + ' ' + module.id"
                                    ghost-class="ghost"
                                    animation="0"
                                    @change="onMove($event, index)"
                                    itemKey="index"
                                    :empty-insert-threshold="10"
                                    :swap-threshold="10"
                                    class="h-10 w-full flex-grow"
                                >
                                    <div
                                        v-if="labelTarget.selectedAnswer.length"
                                        :class="
                                            ' cursor-pointer rounded border p-2 text-[14px] font-semibold' +
                                            ' ' +
                                            (labelTarget.correctAnswer ===
                                            labelTarget.selectedAnswer[0].text
                                                ? 'border-green-500 bg-green-500 text-white'
                                                : 'border-red-400 bg-red-400 text-white') +
                                            ' '
                                        "
                                    >
                                        {{ labelTarget.selectedAnswer[0].text }}
                                    </div>
                                </draggable>
                            </div>
                        </div>
                    </div>
                    <div class="flex h-full flex-col">
                        <div class="flex-shrink font-semibold text-gray-800">
                            All Terms
                        </div>

                        <div class="flex-grow bg-gray-125 p-4">
                            <div class="select-none">
                                <draggable
                                    :disabled="response.module_complete"
                                    class="flex flex-wrap gap-2"
                                    :group="'items' + ' ' + module.id"
                                    ghost-class="ghost"
                                    animation="0"
                                    itemKey="index"
                                    v-model="remainingOptions"
                                    :empty-insert-threshold="100"
                                    :swap-threshold="100"
                                >
                                    <div
                                        class=""
                                        v-for="label in remainingOptions"
                                    >
                                        <div
                                            :class="
                                                'flex h-10 cursor-pointer items-center rounded border bg-white p-2 text-[14px] font-semibold text-gray-925' +
                                                ' ' +
                                                (response.module_complete
                                                    ? 'opacity-50'
                                                    : '')
                                            "
                                        >
                                            {{ label.text }}
                                        </div>
                                    </div>
                                </draggable>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </student-worksheet-module-wrapper>
    </div>
</template>

<script>
import Vue3DraggableResizable, {
    DraggableContainer,
} from "vue3-draggable-resizable";
import "vue3-draggable-resizable/dist/Vue3DraggableResizable.css";

import StudentWorksheetModuleWrapper from "@/Components/StudentWorksheetModuleWrapper";
import { VueDraggableNext } from "vue-draggable-next";

export default {
    name: "StudentWorksheetModuleLabel",
    components: {
        draggable: VueDraggableNext,
        DraggableContainer,
        Vue3DraggableResizable,
        StudentWorksheetModuleWrapper,
    },
    props: ["modelValue", "module", "worksheetComplete"],
    data() {
        return {
            ready: false,
            labelTargets: [],
            remainingOptions: [],
            response: {},
        };
    },

    methods: {
        onMove: function (event, answerLabelIndex) {
            let vm = this;
            let correctLabels = 0;
            let moduleComplete = false;

            if (
                event.added !== undefined &&
                vm.labelTargets[answerLabelIndex].selectedAnswer.length > 1
            ) {
                if (event.added.newIndex === 0) {
                    vm.remainingOptions.push(
                        vm.labelTargets[answerLabelIndex].selectedAnswer[1]
                    );
                    vm.labelTargets[answerLabelIndex].selectedAnswer.splice(
                        1,
                        1
                    );
                } else {
                    vm.remainingOptions.push(
                        vm.labelTargets[answerLabelIndex].selectedAnswer[0]
                    );
                    vm.labelTargets[answerLabelIndex].selectedAnswer.splice(
                        0,
                        1
                    );
                }
            }

            vm.labelTargets.forEach(function (labelTarget) {
                if (
                    labelTarget.selectedAnswer.length &&
                    labelTarget.selectedAnswer[0].text ===
                        labelTarget.correctAnswer
                ) {
                    correctLabels++;
                }
            });

            if (correctLabels === vm.labelTargets.length) {
                moduleComplete = true;
            }

            this.response = {
                labels: vm.labelTargets,
                remaining_options: vm.remainingOptions,
                module_complete: moduleComplete,
            };

            this.inputVal = this.response;

            vm.$forceUpdate();
        },
    },
    mounted() {
        let vm = this;
        let labelTargets = [];
        let remainingOptions = [];
        let moduleComplete =
            vm.modelValue && vm.modelValue.module_complete ? true : false;

        if (vm.modelValue && vm.modelValue.labels.length) {
            // handle user response from older versions of this module
            if (vm.modelValue.labels[0].absolute_position !== undefined) {
                vm.module.content.labels.forEach(function (label, index) {
                    let existingCorrectLabel = null;

                    existingCorrectLabel = _.find(
                        vm.modelValue.labels,
                        function (userResponseLabel) {
                            return (
                                userResponseLabel.text === label.text &&
                                userResponseLabel.correct
                            );
                        }
                    );

                    if (existingCorrectLabel) {
                        labelTargets.push({
                            correctAnswer: label.text,
                            selectedAnswer: [
                                { text: existingCorrectLabel.text },
                            ],
                        });
                    } else {
                        labelTargets.push({
                            correctAnswer: label.text,
                            selectedAnswer: [],
                        });

                        remainingOptions.push({
                            text: label.text,
                        });
                    }
                });
            } else {
                labelTargets = this.modelValue.labels;
                remainingOptions = this.modelValue.remaining_options;
            }
        } else {
            vm.module.content.labels.forEach(function (label, index) {
                labelTargets.push({
                    correctAnswer: label.text,
                    selectedAnswer: [],
                });

                remainingOptions.push({
                    text: label.text,
                });
            });
        }

        vm.response = {
            labels: labelTargets,
            remaining_options: remainingOptions,
            module_complete: moduleComplete,
        };

        vm.remainingOptions = _.shuffle(remainingOptions);
        vm.labelTargets = labelTargets;

        vm.inputVal = vm.response;
        vm.ready = true;
    },
    computed: {
        inputVal: {
            get() {
                return this.modelValue;
            },
            set(val) {
                this.$emit("update:modelValue", val);
            },
        },
    },
};
</script>
